import { Navigate, RouteProps } from "react-router-dom";
import { DashboardPage } from "@/zapi-admin/pages/DashboardPage/DashboardPage";
import { LoginPage } from "@/zapi-admin/pages/LoginPage/LoginPage";
import { VerifyOtpPage } from "@/zapi-admin/pages/VerifyOtpPage/VerifyOtpPage";
import { InviteUserPage } from "@/zapi-admin/pages/InviteUserPage";
import { ImportUsersPage } from "@/zapi-admin/pages/ImportUsersPage";
import { UserSettingsPage } from "@/zapi-admin/pages/UserSettingsPage";
import { GlobalSettingsPage } from "@/zapi-admin/pages/GlobalSettingsPage";
import { OrganizationsPage } from "@/zapi-admin/pages/OrganizationsPage/OrganizationsPage";
import { TemplatesPage } from "@/zapi-admin/pages/TemplatesPage/TemplatesPage";
import { DeficienciesPage } from "@/zapi-admin/pages/DeficienciesPage/DeficienciesPage";
import { PromptsPage } from "@/zapi-admin/pages/PromptsPage/PromptsPage";
import { FeatureFlagsPage } from "@/zapi-admin/pages/FeatureFlagsPage/FeatureFlagsPage";
import { GenerationModePage } from "@/zapi-admin/pages/GenerationModePage/GenerationModePage";
import { ClaudeRunsPage } from "@/zapi-admin/pages/ClaudeRunsPage/ui/ClaudeRunsPage";
import { ClaudeRunPage } from "@/zapi-admin/pages/ClaudeRunsPage/ui/ClaudeRunPage";

import {
  AppRoutes,
  getRouteDashboard,
  getRouteSignIn,
  getRouteVerifyOtp,
  getRouteInviteUser,
  getRouteImportUsers,
  getRouteCriteriaLogs,
  geRouteAiLogs,
  getRouteAuthLogs,
  getRouteAiEvals,
  getRouteUserSettings,
  getRouteGlobalSettings,
  getRouteOrganizations,
  getRouteTemplates,
  getRouteDeficiencies,
  getRoutePrompts,
  getRouteFeatureFlags,
  getRouteGenerationMode,
  getRouteClaudeRuns
} from "@/zapi-admin/shared/const/router";
import { LogsPage } from "@/zapi-admin/pages/LogsPage/LogsPage";
import { AiLogsPage } from "@/zapi-admin/pages/AiLogsPage/ui/AiLogsPage";
import { AuthLogsPage } from "@/zapi-admin/pages/AuthLogsPage";
import { AiEvalsPage } from "@/zapi-admin/pages/AiEvalsPage";

type TRouteAccess = "protected" | "nonprotected" | "public";

export type AppRoutesProps = RouteProps & {
  routePrivilege: TRouteAccess;
};

export const routeConfig: Record<AppRoutes, AppRoutesProps> = {
  [AppRoutes.ROOT]: {
    path: "/",
    element: <Navigate to={getRouteDashboard()} />,
    routePrivilege: "public"
  },
  [AppRoutes.DASHBOARD]: {
    path: getRouteDashboard(),
    element: <DashboardPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.SIGN_IN]: {
    path: getRouteSignIn(),
    element: <LoginPage />,
    routePrivilege: "public"
  },
  [AppRoutes.VERIFY_OTP]: {
    path: getRouteVerifyOtp(),
    element: <VerifyOtpPage />,
    routePrivilege: "public"
  },
  [AppRoutes.INVITE_USER]: {
    path: getRouteInviteUser(),
    element: <InviteUserPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.IMPORT_USERS]: {
    path: getRouteImportUsers(),
    element: <ImportUsersPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.CRITERIA_LOGS]: {
    path: getRouteCriteriaLogs(),
    element: <LogsPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.AI_LOGS]: {
    path: geRouteAiLogs(),
    element: <AiLogsPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.AUTH_LOGS]: {
    path: getRouteAuthLogs(),
    element: <AuthLogsPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.AI_EVALS]: {
    path: `${getRouteAiEvals()}/*`,
    element: <AiEvalsPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.AI_EVALS_CLAIMS]: {
    path: "",
    element: null,
    routePrivilege: "protected"
  },
  [AppRoutes.AI_EVALS_CHAT]: {
    path: "",
    element: null,
    routePrivilege: "protected"
  },
  [AppRoutes.AI_EVALS_INTELLIGENCE]: {
    path: "",
    element: null,
    routePrivilege: "protected"
  },
  [AppRoutes.USER_SETTINGS]: {
    path: getRouteUserSettings(),
    element: <UserSettingsPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.GLOBAL_SETTINGS]: {
    path: getRouteGlobalSettings(),
    element: <GlobalSettingsPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.ORGANIZATIONS]: {
    path: getRouteOrganizations(),
    element: <OrganizationsPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.TEMPLATES]: {
    path: getRouteTemplates(),
    element: <TemplatesPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.DEFICIENCIES]: {
    path: getRouteDeficiencies(),
    element: <DeficienciesPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.PROMPTS]: {
    path: `${getRoutePrompts()}/*`,
    element: <PromptsPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.PROMPTS_FEATURE]: {
    path: "",
    element: null,
    routePrivilege: "protected"
  },
  [AppRoutes.FEATURE_FLAGS]: {
    path: getRouteFeatureFlags(),
    element: <FeatureFlagsPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.GENERATION_MODE]: {
    path: getRouteGenerationMode(),
    element: <GenerationModePage />,
    routePrivilege: "protected"
  },
  [AppRoutes.CLAUDE_RUNS]: {
    path: getRouteClaudeRuns(),
    element: <ClaudeRunsPage />,
    routePrivilege: "protected"
  },
  [AppRoutes.CLAUDE_RUN]: {
    path: `${getRouteClaudeRuns()}/:id`,
    element: <ClaudeRunPage />,
    routePrivilege: "protected"
  }
};
